import { Directive, Input, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appTextSize]',
})
export class TextSizeDirective implements OnInit {
  @Input() gradeLevel: number | string;
  constructor(private el: ElementRef) {}

  ngOnInit(): void {
    this.setFontSize();
  }

  private setFontSize() {
    let fontClass: string = '';
    switch (this.gradeLevel) {
      case 0:
        fontClass = 'KINDERGARTEN';
        break;
      case 'TK':
        fontClass = 'TK';
        break;
      case 'K':
        fontClass = 'KINDERGARTEN';
        break;
      case '1st':
        fontClass = 'FIRST';
        break;
      case 1:
        fontClass = 'FIRST';
        break;
      case '2nd':
        fontClass = 'SECOND';
        break;
      case 2:
        fontClass = 'SECOND';
        break;
      case 3:
        fontClass = 'THIRD';
        break;
      case '3rd':
        fontClass = 'THIRD';
        break;
      case 4:
        fontClass = 'FOURTH';
        break;
      case '4th':
        fontClass = 'FOURTH';
        break;
      case 5:
        fontClass = 'FIFTH';
        break;
      case '5th':
        fontClass = 'FIFTH';
        break;
      case 6:
        fontClass = 'SIXTH';
        break;
      case '6th':
        fontClass = 'SIXTH';
        break;
      default:
        break;
    }
    if (fontClass) this.el.nativeElement.classList.add(fontClass);
  }
}
